// KPI events: track(name, props) → POST /api/events + the demo-menu log panel.
// Use it for browser-side events only (paywall_viewed, upgrade_started, digest_opened). API writes record
// their own event server-side and return it in `events`; pass those to logServerEvents so nothing fires twice.
import type { KpiEvent } from '../../domain/types';

type Listener = (events: KpiEvent[]) => void;
let log: KpiEvent[] = [];
const listeners = new Set<Listener>();
const emit = () => listeners.forEach((l) => l(log));

export function track(name: KpiEvent['name'], props: KpiEvent['props'] = {}): KpiEvent {
  const ev: KpiEvent = { name, at: new Date().toISOString(), props };
  log = [...log, ev];
  emit();
  void fetch('/api/events', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(ev) }).catch(() => {});
  return ev;
}

export function logServerEvents(events: KpiEvent[] | undefined) {
  if (!events?.length) return;
  log = [...log, ...events];
  emit();
}

export const getEvents = () => log;
export const clearEvents = () => { log = []; emit(); };
export function subscribeEvents(l: Listener) { listeners.add(l); return () => { listeners.delete(l); }; }

// e2e hook: specs read window.__wtEvents to assert "logged exactly once".
declare global { interface Window { __wtEvents?: () => KpiEvent[] } }
if (typeof window !== 'undefined') window.__wtEvents = getEvents;
